;(function($, window, document, undefined) {

  const pluginName = 'popUp';

  class PopUp {

    constructor(element, options) {

      this._name = pluginName;
      this._defaults = $.fn[pluginName].defaults;

      this.element = element;
      this.settings = $.extend(true, this._defaults, options);

      this.init();

    }

    init() {
      this.cacheElements();
      this.bindEvents();
    }

    cacheElements() {
      this.$element = $(this.element);
    }

    bindEvents() {
      this.$element.on('click', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        PopUp.open(url, this.settings);
      });
    }

    static open (path, options) {
      let settings = $.extend(true, $.fn[pluginName].defaults, options);

      if (!path) {
        console.error("Can't open a new window without an address. Please, inform one.");
        return;
      }

      // Fixes dual-screen position                         Most browsers      Firefox
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      var systemZoom = width / window.screen.availWidth;
      var left = (width - settings.width) / 2 / systemZoom + dualScreenLeft;
      var top = (height - settings.height) / 2 / systemZoom + dualScreenTop;
      var newWindow = window.open(path, settings.title, 'scrollbars=yes, width=' + settings.width / systemZoom + ', height=' + settings.height / systemZoom + ', top=' + top + ', left=' + left);

      // Puts focus on the newWindow
      if (window.focus) newWindow.focus();
    }
  }

  $[pluginName] = PopUp.open;

  $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new PopUp(this, options));
      }
    });
  };

  $.fn[pluginName].defaults = {
    path: null,
    title: 'Compartilhar',
    width: 626,
    height: 436
  };

})(jQuery, window, document);
